export default __webpack_public_path__ + "static/media/icon_seccion_inactiva.38b9e57d.svg";